import React, { useState, createContext, useContext, useEffect } from 'react';
import * as Icon from "@ant-design/icons";
import { Breadcrumb, Layout, Menu, theme } from 'antd';
import PageRoutes from "./PageRoutes"

import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";

const { Header, Content, Footer, Sider } = Layout;

const AppLayoutContext = createContext();


const MainLayout = () => {
  const [menuCollapsed, setMenuCollapsed] = useState(false);
  const {
    token
  } = theme.useToken();
  const navigate = useNavigate();

  const location = useLocation();
  useEffect(() => {
    console.log(" location.pathname", location.pathname)

    var isLoginPages = ["/login", "/reset-password", "/register", "/thank-you"].includes(location.pathname);
    isLoginPages = true;
    if (!isLoginPages) {
      //navigate login page
      navigate("/login");
    }
  }, [])

  return (
    <div>
      <PageRoutes></PageRoutes>
    </div>
  );
};

const useAppLayoutContext = () => {
  return useContext(AppLayoutContext);
}


const App = () => {
  return (
    <BrowserRouter basename="/">

   
        <MainLayout></MainLayout>

    </BrowserRouter>
  )
}
export { useAppLayoutContext }
export default App;